import { useContext } from 'react';
import sortByPosition from '@/lib/utils/sorting/sortByPosition';
import getHighestPositionFromSortedItems from '@/pages/EditorPage/getHighestPositionFromSortedItems';
import ModelEditorCard from './ModelEditorCard';
import ModelSectionEditor from './ModelSectionEditor';
import AddModelSection from './AddModelSection';
import SelectedModelIdContext from '../SelectedModelIdContext';
import ModelsContext from '../ModelsContext';

const ModelEditor = () => {
  const [models] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);

  const sections = Object.values(models[selectedModelId].sections);
  const sortedSections = sections.sort(sortByPosition);
  const highestSectionPosition =
    getHighestPositionFromSortedItems(sortedSections);

  return (
    <ModelEditorCard variant="outlined">
      {sortedSections.map((section, index) => (
        <ModelSectionEditor
          section={section}
          previousSection={sortedSections[index - 1] ?? null}
          nextSection={sortedSections[index + 1] ?? null}
          key={section.id}
        />
      ))}
      <AddModelSection highestSectionPosition={highestSectionPosition} />
    </ModelEditorCard>
  );
};

export default ModelEditor;
